const Menu = {
  en: ['CAREFREE', 'Home', 'College', 'Position', 'Planning', 'Consultant', 'About'],
  cn: ['无忧规划', '主页', '无忧高报', '三环定位', '六维规划', '专业顾问', '关于'],
};
const Home = {
  // en: ['Clearly define position', 'Master application skills', 'Know college & major', 'Simulate enrollment application'],
  // cn: ['明确自身定位', '掌握志愿技巧', '了解院校专业', '模拟志愿填报'],
  en: [
    [
      'We Believes',
      'Academic planning ≠ Filling out applications ≠ Choosing a college', 
      'The truth about academic planning is:\n❗ A dynamic navigation system spanning the entire K12 journey\n❗ A precision-matched roadmap integrating academic potential + career aptitude + educational pathways\n❗ A future-driven learning strategy aligned with personal growth and societal needs\n❗ A scientific framework breaking down goals into actionable steps', 
      'Education is not the filling of a pail (rote memorization), but the lighting of a fire (inspiration).True academic planning ignites the spark best suited to a child’s potential—lighting the path ahead with purpose.'
    ],
    [
      "We Provides",
      'CEE Self-Service College Application System',
      '"CEE Carefree" is part of Carefree Tech’s "Carefree Academic Planning" product series. Based on the "Three-Circle Positioning" model, it assesses students’ academic strengths, career aptitudes, and growth potential to determine optimal academic and professional pathways—guiding university and major selection.',
      'Personalized Application Generation: Produces multiple customizable "University + Major Group" preference lists (with visual aids) for students and parents to evaluate.',
      'Expert Counselor Support: Backed by dozens of advisors with 10+ years of Gaokao application experience, providing real-time guidance on application strategies.',
      'Youth "Carefree Academic Planning" Service',
      'Six-Dimensional Assessment: Evaluates academic ability, career inclination, personal traits, family resources, policy trends, and societal needs to create tailored academic roadmaps.',
      'Subject Selection & Extracurricular Guidance: Aligns high school course choices with university majors and future careers, while designing competency-based background enhancement plans.',
      'Career Development Pathway: Maps skill-building steps (courses, internships, etc.) to bridge academic goals with professional aspirations.',
      'Dynamic Progress Tracking: Monitors academic/personal growth, identifies challenges, and forecasts future competitiveness to ensure steady advancement.',
    ],
  ],
  cn: [
    [
      '我们认为', 
      '学业规划 ≠ 填志愿 ≠ 选学校', 
      '学业规划的真相是：\n❗ 贯穿K12全过程的动态导航系统\n❗ 涵盖学科潜能+职业倾向+升学路径的精准匹配\n❗ 以个人发展及社会需求为目标、投射到成长历程的学习规划\n❗ 将个人学业规划的目标拆解为可执行步骤的科学方案', 
      '教育不是注满一桶水（填鸭），而是点燃一把火（启迪）。专业的学业规划，应该是找到最适合孩子的火种，让成长之路自带光芒。'
    ],
    [
      '我们提供', 
      '高三生“高报无忧”自助',
      '全称为“无忧高考志愿填报-自助生成系统”，是无忧科技公司的“无忧学业规划”系列产品之一，该产品以“三环定位”模型为基础，基于对高考生学业、职业、成长的测评，定位其学业及职业方向，进而指导其大学的专业与院校的选择。',
      '个性化志愿生成：“无忧高报”将生成多套、可行、可移动调整的“院校+专业组”的志愿列表，供家长及学生权衡选择。',
      '高报师专业指导：同时配备有数十名具有十余年高考志愿填报指导经验的老师/咨询师以同步解答家长及学生在志愿填报过程中的各类专业问题。',
      '中学生“无忧规划”服务',
      '六维模型评估：涵盖学科能力、职业倾向、个人特质、家庭资源、政策预警、社会需求六个方面，全方位考量学生情况，生成个性化的学业规划方案。',
      '选科与课外活动指导：结合高校专业设置及未来职业发展方向，为学生提供科学的选科建议，并匹配目标职业胜任力模型进行背景提升规划，为个人发展打下坚实基础。',
      '职业能力发展路径规划：根据学生的职业目标和自身条件，制定详细职业能力提升计划，包括所需技能、课程学习、实习实践等，让学生清晰了解从学业到职业的每一步。',
      '动态追踪成长轨迹：持续监测学生在学业、家庭、个人特质等方面的变化，及时发现其成长过程中的变化和问题，预测未来竞争力，助力学生在学业道路上稳步前行。',
    ],
  ],  
};
const College = {
  en: ['College List', 'College Detail', 'Major List', 'Major Detail'],
  cn: ['院校列表', '院校详情', '专业列表', '专业详情'],
};
const Position = {
  en: ['3-Ring Position Evaluation', 'Your Evaluation Report', 'Save'],
  cn: ['三环定位测评', '你的测评报告', '保存报告'],
};
const Planning = {
  en: ['6-Dim Planning'],
  cn: ['六维规划'],
};
const Consultant = {
  en: ['Professional Consultant'],
  cn: ['专业顾问'],
};
const AboutUs = {
  en: [
    [
      'Carefree Tech Believes',
      '❗ A dynamic navigation system spanning the entire K12 journey\n❗ A precision-matched roadmap integrating academic potential + career aptitude + educational pathways\n❗ A future-driven learning strategy aligned with personal growth and societal needs\n❗ A scientific framework breaking down goals into actionable steps', 
      'Education is not the filling of a pail (rote memorization), but the lighting of a fire (inspiration).True academic planning ignites the spark best suited to a child’s potential—lighting the path ahead with purpose.'
    ],
    [
      "Carefree Tech Provides",
      'CEE Self-Service College Application System',
      '"CEE Carefree" is part of Carefree Tech’s "Carefree Academic Planning" product series. Based on the "Three-Circle Positioning" model, it assesses students’ academic strengths, career aptitudes, and growth potential to determine optimal academic and professional pathways—guiding university and major selection.',
      'Personalized Application Generation: Produces multiple customizable "University + Major Group" preference lists (with visual aids) for students and parents to evaluate.',
      'Expert Counselor Support: Backed by dozens of advisors with 10+ years of Gaokao application experience, providing real-time guidance on application strategies.',
      'Youth "Carefree Academic Planning" Service',
      'Six-Dimensional Assessment: Evaluates academic ability, career inclination, personal traits, family resources, policy trends, and societal needs to create tailored academic roadmaps.',
      'Subject Selection & Extracurricular Guidance: Aligns high school course choices with university majors and future careers, while designing competency-based background enhancement plans.',
      'Career Development Pathway: Maps skill-building steps (courses, internships, etc.) to bridge academic goals with professional aspirations.',
      'Dynamic Progress Tracking: Monitors academic/personal growth, identifies challenges, and forecasts future competitiveness to ensure steady advancement.',
    ],
    [
      'Meet our Management Team',
      {
        name:'Chris', 
        slogan: 'The journey around the world has just begun',
        desc:[
          'With nearly 20 years of corporate management experience, I have served as HR Director at several well-known listed conglomerates and as a senior executive in diversified enterprises. I co-founded a non-profit learning organization for HR professionals in the Haixi region. Since 2004, I have been involved in vocational education, and in 2018, I collaborated with universities on international education initiatives. Continuously exploring and applying innovative approaches in the fields of education and technology, I have produced research achievements in education studies and academic planning.'
        ]
      },
      {
        name:'Johnson', 
        slogan: 'First developer from Fuzhou to program in the Arctic',
        desc:[
          'With 7 years of experience as the founder of two startups in Canada and 14 years as the founding director of four core R&D departments at a Chinese internet-listed company, I have a strong entrepreneurial and technical leadership background. Additionally, I served as a full-time Associate Professor at Minjiang University for 11 years, alongside roles as a guest professor at Fuzhou University and Fujian Normal University. Boasting over 30 years of coding experience, I have developed more than 20 software products and multiple smart hardware devices. My academic contributions include publishing 20+ research papers.'
        ]
      },
      {
        name:'Sherly', 
        slogan: 'No matter where you are, you are at the top of the earth',
        desc:[
          'MBA from the University of Science and Technology of China (USTC). With extensive management experience at multiple large enterprises and listed companies, I possess deep expertise in business strategy, technology transfer, financing, commercial analysis, and capital operations.'
        ]
      },
    ],
  ],
  cn: [
    [
      '无忧科技认为', 
      '学业规划 ≠ 填志愿 ≠ 选学校，学业规划的真相是：\n❗ 贯穿K12全过程的动态导航系统\n❗ 涵盖学科潜能+职业倾向+升学路径的精准匹配\n❗ 以个人发展及社会需求为目标、投射到成长历程的学习规划\n❗ 将个人学业规划的目标拆解为可执行步骤的科学方案', 
      '教育不是注满一桶水（填鸭），而是点燃一把火（启迪）。专业的学业规划，应该是找到最适合孩子的火种，让成长之路自带光芒。'
    ],
    [
      '无忧科技提供', 
      '“高报无忧”自助志愿生成服务',
      '“高报无忧”全称“高考志愿填报无忧辅助系统”，是无忧科技公司“无忧学业规划”系列产品之一，该产品以“三环定位”模型为基础，基于对高考生学业、职业、成长的测评，定位其学业及职业方向，进而指导其大学的专业与院校的选择。',
      '个性化志愿生成：“高报无忧”将生成多套、可行、可移动调整的“院校+专业组”的志愿列表（图示），供家长及学生权衡选择。',
      '高报师专业指导：同时配备有数十名具有十余年高考志愿填报指导经验的老师/咨询师以同步解答家长及学生在志愿填报过程中的各类专业问题。',
      '青少年“无忧学业规划”服务',
      '六维模型评估：涵盖学科能力、职业倾向、个人特质、家庭资源、政策预警、社会需求六个方面，全方位考量学生情况，生成个性化的学业规划方案。',
      '选科与课外活动指导：结合高校专业设置及未来职业发展方向，为学生提供科学的选科建议，并匹配目标职业胜任力模型进行背景提升规划，为个人发展打下坚实基础。',
      '职业能力发展路径规划：根据学生的职业目标和自身条件，制定详细职业能力提升计划，包括所需技能、课程学习、实习实践等，让学生清晰了解从学业到职业的每一步。',
      '动态追踪成长轨迹：持续监测学生在学业、家庭、个人特质等方面的变化，及时发现其成长过程中的变化和问题，预测未来竞争力，助力学生在学业道路上稳步前行。',
    ],
    [
      '无忧科技管理团队', 
      {
        name:'Chris',
        slogan: '环绕世界的旅行刚刚开始',
        desc:[
          '近20年企业管理实践，历任多家知名上市集团HR总监、多元化企业高管，曾联合创立海西人力资源学习型公益组织；2004年起涉足职业教育、2018年与高校合作国际教育，在教育与科技领域不断探索与实战，已产生教育研究、学业规划领域的相关成果。',
        ]
      },
      {
        name:'Johnson',
        slogan: '首位在北极编程的福州籍程序员',
        desc:[
          '7年加拿大2家创业公司创始人、14年中国互联网上市公司4个核心研发部门创始总监，11年闽江学院专职副教授以及福州大学、福建师范大学外聘教授，30年以上代码经验，开发过超20个软件产品及多个智能硬件产品，发表论文20余篇。'
        ]
      },
      {
        name:'Sherly',
        slogan: '无论身处何地 都是大地之巅',
        desc:[
          '中国科技大学工商管理硕士，曾在多家大型企业、上市公司担任管理职位，对企业经营规划、技术转移转化、融资、商业分析及资金等领域具有丰富的从业经验。'
        ]
      }
    ]
  ],
};
const Claim = {
  en: [
    'Carefree Technology Ltd.', 
    'Wechat: tongtuplan',
    // 'info@carefree.cn',
    'Room 122, 1st Floor, National University Science Park of Fuzhou University',
    'No. 523, Gongye Road, Hongshan Town, Gulou District, Fuzhou City, Fujian Province, China',
    'Payment by',
    'Terms of Service',
    'Privacy Policy',
    'Copyright',
  ],
  cn: [
    '无忧科技有限公司',
    '微信号 tongtuplan',
    // 'info@carefree.cn',
    '福州大学国家大学科技园1层122室',
    '福建省福州市鼓楼区洪山镇工业路523号',
    '支付合作',
    '服务条款',
    '隐私政策',
    '版权所有',
  ],
};
const Ads = {
  en: [
    'Since 2015, HOMAPP is the first of a mobile app for Chinese real estate in Canada, and has now expanded the language categories to 5 to express respect for the multiculturalism of Canada.', 
    'Please download!'
  ],
  cn: [
    '自2015年，HOMAPP第一个在加拿大推出了中文地产应用，现已将语言种类扩展到了5个，以表达对多加拿大多元文化的敬意。',
    '敬请下载！'
  ],
};


export const Lang = {
  Menu,
  Home,
  College,
  Position,
  Planning,
  Consultant,
  AboutUs,
  Claim,
  Ads,
}